import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

// Tooltip component for medical terms
const MedicalTerm = ({ term, definition, anatomyPage, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <span 
      className="medical-term-wrapper"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onFocus={() => setShowTooltip(true)}
      onBlur={() => setShowTooltip(false)}
      tabIndex={0}
    >
      <span className="medical-term">
        {children}
        <HelpCircle size={12} className="term-icon" />
      </span>
      
      {showTooltip && (
        <span className="medical-tooltip" role="tooltip">
          <span className="tooltip-term">{term}</span>
          <span className="tooltip-definition">{definition}</span>
          {anatomyPage && (
            <Link 
              to={anatomyPage} 
              className="tooltip-link"
              onClick={(e) => e.stopPropagation()}
            >
              Learn more →
            </Link>
          )}
        </span>
      )}
    </span>
  );
};

export default MedicalTerm;
